<ng-container *ngIf="tooltip$ | async as tooltip">
  <div
    #container
    class="tooltippy tooltippy-{{ placement }}"
    role="dialog"
    [attr.aria-label]="[tooltip.arialabelResourceKey | tekstresource]"
    [style.left.px]="left"
    [style.top.px]="top"
  >
    <div class="row paging">
      <div class="col"></div>
      <div class="col col-auto">{{ tooltip.step }}/{{ tooltip.maxSteps }}</div>
    </div>
    <div class="row header pb-4">
      {{ tooltip.titleResourceKey | tekstresource }}
    </div>
    <div class="body pb-4">
      {{ tooltip.descriptionResourceKey | tekstresource }}
    </div>
    <div class="row footer align-items-center">
      <div class="col">
        <ng-container *ngIf="tooltip.step == tooltip.maxSteps">
          <input
            [id]="'dontShow_' + tutorialSequenceId"
            type="checkbox"
            (change)="setDontShowAgain($event.target.checked)"
            class="form-checkbox"
          />
          <label [for]="'dontShow_' + tutorialSequenceId">Vis ikke igen</label>
        </ng-container>
      </div>
      <div class="col-auto">
        <button class="button button-primary btn-tooltip px-7" (click)="onOK()">OK</button>
      </div>
    </div>
  </div>
</ng-container>
